module.exports = __webpack_public_path__ + "img/logo-dark.8cc5d250.png";